import { mapKeys, omit } from 'lodash';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import skillookAdmin from 'apis/skillookAdmin';

// First, create the thunk
export const allUserListRequest = createAsyncThunk(
  'allUserList',
  async limitArr => {
    const [keyword, filter, start, limit] = limitArr;
    if (keyword.trim()) {
      const response = await skillookAdmin.get(
        `admin/users/search?skip=${start}&limit=${limit}&searchType=${filter}&keyword=${keyword}`
      );
      return response.data.data;
    } else {
      const response = await skillookAdmin.get(
        `admin/users/all?skip=${start}&limit=${limit}&searchType=${filter}`
      );
      return response.data.data;
    }
  }
);

export const deleteUserRequest = createAsyncThunk(
  'deleteUser',
  async payload => {
    await skillookAdmin.delete('admin/users/delete', { data: payload });
    return payload.userID;
  }
);

export const blockUnblockUserRequest = createAsyncThunk(
  'blockUnblockUser',
  async payload => {
    await skillookAdmin.post('admin/users/block', payload);
    return payload;
  }
);

// Then, handle actions in your reducers:
const allUserListSlice = createSlice({
  name: 'allUserList',
  initialState: { list: {}, totalUsers: 0, refreshPage: false },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyAllUserList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [allUserListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: { ...mapKeys(action.payload.users, '_id') },
        totalUsers: action.payload.totalusersCount,
        refreshPage: false,
      };
    },
    [deleteUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: omit(state.list, action.payload),
        loading: false,
        refreshPage: true,
      };
    },
    [deleteUserRequest.pending]: state => {
      return {
        ...state,
        loading: true,
      };
    },
    [deleteUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
        message: 'User Deletion Failed',
      };
    },
    [blockUnblockUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload.userId]: {
            ...state.list[action.payload.userId],
            status: action.payload.status,
            loading: false,
          },
        },
      };
    },
    [blockUnblockUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
        message: 'User Activation Failed',
      };
    },
  },
});

export const { emptyAllUserList } = allUserListSlice.actions;
export default allUserListSlice.reducer;
